// extracted by mini-css-extract-plugin
export default {"green_banner":"green_banner_green_banner__o2mqr","button":"green_banner_button__S7aTP","primary":"green_banner_primary__4QW-w","smallTitle":"green_banner_smallTitle__ccBJ+"};